import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';

import NotFoundPage from './404';
import PageData from '../helpers/pageData';
import Layout from '../components/Layouts/Layout';
import Body from '../components/ui/Body/Body';
import getPageContextFromData from '../lib/dto/getPageContextFromData';

const EventsPage = ({
  data: { prismicEventsPage: { type, uid, data } },
}) => {
  if (!data) return <NotFoundPage />;

  const dataContext = getPageContextFromData(type, uid, { ...data, body: data.body1});

  return (
    <PageData.Provider value={dataContext}>
      <Layout>
        <Body />
      </Layout>
    </PageData.Provider>
  );
};

export const query = graphql`
{
  prismicEventsPage {
    _previewable
    uid
    type
    data {
      title
      seo_title
      seo_description
      prismic_page_name
      page_short_description
      page_colour
      introduction
      body1 {
        ... on PrismicEventsPageDataBody1Content {
          id
          slice_type
          primary {
            content_heading {
              html
              text
            }
            content_subtitle {
              richText
              html
              text
            }
            content_text {
              richText
              text
            }
            layout
          }
        }
        ... on PrismicEventsPageDataBody1UpcomingEvents {
          id
          slice_type
          primary {
            events_title {
              text
            }
          }
        }
        ... on PrismicEventsPageDataBody1PastEvents {
          id
          slice_type
          primary {
            events_title {
              text
            }
          }
        }
      }
    }
  }
}
`;

EventsPage.propTypes = {
  data: PropTypes.shape({
    prismicEventsPage: PropTypes.object.isRequired,
  }).isRequired,
};

export default withPrismicPreview(EventsPage);
